module.exports = __webpack_public_path__ + "static/media/brisa.5c65e3b3.webp";